import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid";
import { ThemeProvider } from "@mui/material";
import theme, { mainColor } from "src/styles/mainstyle";
import ContentBox from "src/components/ContentBox/ContentBox";
import { howItWorks } from "src/media/texts/howItWorks";
import { useMediaQuery, useTheme } from "@mui/material";
import MainButton from "src/components/buttons/mainbutton";
import { useNavigate } from "react-router-dom";

export default function StillUnsure() {
  // const [liked, setLiked] = useState(false);
  // const [likeCount, setLikeCount] = useState(100000);
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <ContentBox title="" id={"how-it-works"}>
      <Grid container spacing={!isDesktop ? 15 : 5}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "bold", marginBottom: "20px" }}
          >
            How it works
          </Typography>
          {howItWorks.questions.map((item, index) => (
            <AccordionWrapper
              key={index}
              question={String(index + 1) + ". " + item.header}
              answer={item.answer}
              smallVersion={true}
            />
          ))}
          <MainButton
            sx={{ mt: 3 }}
            onClick={() => navigate("/homes")}
            text={"Find homes"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div
            style={{
              position: "relative",
              paddingBottom: "56.25%",
              height: 0,
              overflow: "hidden",
              maxWidth: "100%",
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "12px",
              }}
              src="https://www.youtube.com/embed/grt6F9EiAlA?si=0scEf3_-pikgq8tY"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          {/* <IconButton
              color={liked ? "secondary" : "default"}
              onClick={() => {
                setLiked(!liked);
                setLikeCount(liked ? likeCount - 1 : likeCount + 1);
              }}
            >
              <ThumbUpIcon />
              {likeCount}
            </IconButton> */}
        </Grid>
      </Grid>
    </ContentBox>
  );
}

type AccordionWrapperProps = {
  answer: string;
  question: string;
  smallVersion?: boolean;
};

export function AccordionWrapper({
  answer,
  question,
  smallVersion,
}: AccordionWrapperProps) {
  return (
    <ThemeProvider
      theme={{
        ...theme,
        palette: {
          ...theme.palette,
          primary: {
            main: mainColor,
          },
        },
        shadows: Array(25).fill("none"), // Remove all shadows
      }}
    >
      <Accordion sx={{ borderRadius: 2 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-content-${question}`}
          id="panel-header-{question}"
          sx={{
            flexDirection: "row",
            backgroundColor: theme.palette.primary.main,
          }}
        >
          <Typography
            sx={{ color: "black" }}
            variant={smallVersion ? "h5" : "h3"}
          >
            {question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: theme.palette.primary.main }}>
          <Typography
            variant={smallVersion ? "h6" : "h5"}
            sx={{
              fontWeight: 400,
              whiteSpace: "pre-line",
            }}
          >
            {answer}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </ThemeProvider>
  );
}
